<div class="kpi-cards" *ngIf="snapshot">
    <div class="kpi-card">
        <div class="kpi-label">{{ 'pages.collections.analytics.registered_users' | translate }}</div>
        <div class="kpi-value">{{ snapshot.registeredUsers | number }}</div>
        <div class="kpi-subtitle muted" *ngIf="engagementRate !== null">
            {{ 'pages.collections.analytics.engagement_rate' | translate }}: {{ engagementRate }}%
        </div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'pages.collections.analytics.total_views' | translate }}</div>
        <div class="kpi-value">{{ snapshot.totalViews.value | number }}</div>
        <div class="kpi-subtitle" *ngIf="viewsDelta !== null"
             [class.positive]="viewsDelta > 0" [class.negative]="viewsDelta < 0" [class.muted]="viewsDelta === 0">
            <span *ngIf="viewsDelta > 0">&#9650;</span>
            <span *ngIf="viewsDelta < 0">&#9660;</span>
            <span *ngIf="viewsDelta === 0">&mdash;</span>
            {{ viewsDelta > 0 ? '+' : '' }}{{ viewsDelta | number }} {{ 'pages.collections.analytics.vs_previous' | translate }}
        </div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'pages.collections.analytics.unique_viewers' | translate }}</div>
        <div class="kpi-value">{{ snapshot.uniqueViewers.value | number }}</div>
        <div class="kpi-subtitle" *ngIf="viewersDelta !== null"
             [class.positive]="viewersDelta > 0" [class.negative]="viewersDelta < 0" [class.muted]="viewersDelta === 0">
            <span *ngIf="viewersDelta > 0">&#9650;</span>
            <span *ngIf="viewersDelta < 0">&#9660;</span>
            <span *ngIf="viewersDelta === 0">&mdash;</span>
            {{ viewersDelta > 0 ? '+' : '' }}{{ viewersDelta | number }} {{ 'pages.collections.analytics.vs_previous' | translate }}
        </div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'pages.collections.analytics.total_downloads' | translate }}</div>
        <div class="kpi-value">{{ snapshot.totalDownloads.value | number }}</div>
        <div class="kpi-subtitle" *ngIf="downloadsDelta !== null"
             [class.positive]="downloadsDelta > 0" [class.negative]="downloadsDelta < 0" [class.muted]="downloadsDelta === 0">
            <span *ngIf="downloadsDelta > 0">&#9650;</span>
            <span *ngIf="downloadsDelta < 0">&#9660;</span>
            <span *ngIf="downloadsDelta === 0">&mdash;</span>
            {{ downloadsDelta > 0 ? '+' : '' }}{{ downloadsDelta | number }} {{ 'pages.collections.analytics.vs_previous' | translate }}
        </div>
    </div>
    <div class="kpi-card">
        <div class="kpi-label">{{ 'pages.collections.analytics.download_rate' | translate }}</div>
        <div class="kpi-value">{{ snapshot.downloadRate.value }}%</div>
        <div class="kpi-subtitle" *ngIf="downloadRateDelta !== null"
             [class.positive]="downloadRateDelta > 0" [class.negative]="downloadRateDelta < 0" [class.muted]="downloadRateDelta === 0">
            <span *ngIf="downloadRateDelta > 0">&#9650;</span>
            <span *ngIf="downloadRateDelta < 0">&#9660;</span>
            <span *ngIf="downloadRateDelta === 0">&mdash;</span>
            {{ downloadRateDelta > 0 ? '+' : '' }}{{ downloadRateDelta }}% {{ 'pages.collections.analytics.vs_previous' | translate }}
        </div>
    </div>
</div>
